import { useMemo } from 'react';

import type { PricingTotals } from '../_components/Tables/ExperiencesTable/PricingTotals.types';
import { computePricingTotals } from '../_utils/packContent.utils';

import { usePackAddOns } from './usePackAddOns';
import { usePackExperiences } from './usePackExperiences';
import { usePackRooms } from './usePackRooms';
import { useSelectedPack } from './useSelectedPack';

export const usePackContent = () => {
  const { packages: selectedPack, alwaysIncludedXps } = useSelectedPack();

  const experiences = usePackExperiences(selectedPack, alwaysIncludedXps);
  const addOns = usePackAddOns(selectedPack);
  const rooms = usePackRooms(selectedPack);

  const pricingTotals = useMemo((): PricingTotals => {
    const allExps = [
      ...experiences.includedExperience,
      ...experiences.alwaysIncludedXps,
    ];

    return computePricingTotals(allExps);
  }, [experiences]);

  return { experiences, pricingTotals, addOns, rooms };
};
